// Teams views
import Teams from '@/views/Teams.vue';
import TeamsList from '@/views/Teams/TeamsList.vue';
import TeamInfo from '@/views/Teams/TeamInfo.vue';
import TeamsUsers from '@/views/Teams/components/TeamInfo/Users.vue';
import TeamsPermissions from '@/views/Teams/components/TeamInfo/Permissions.vue';
import UserCard from '@/views/Teams/UserCard.vue';

export default [
  {
    path: '/teams',
    name: 'teams',
    component: Teams,
    meta: {
      requiresAuth: true,
      view: 'teams',
    },
    children: [
      // {
      //   path: 'all',
      //   component: TeamsList,
      //   name: 'teams.all',
      //   meta: {
      //     view: 'teamsList',
      //   },
      //   children: [
      //     {
      //       path: 'details',
      //       component: TeamInfo,
      //       name: 'teams.all.details',
      //       meta: {
      //         view: 'TeamInfo',
      //       },
      //       children: [
      //         {
      //           path: 'users',
      //           component: TeamsUsers,
      //           name: 'teams.all.details.all-users',
      //           meta: {
      //             view: 'users',
      //           },
      //         },
      //       ],
      //     },
      //   ],
      // },
      {
        path: ':id',
        component: TeamsList,
        name: 'teams.teams-list',
        meta: {
          view: 'teamsList',
        },
        children: [
          {
            path: 'details',
            component: TeamInfo,
            name: 'teams.teams-list.details',
            meta: {
              view: 'TeamInfo',
            },
            children: [
              {
                path: 'users',
                component: TeamsUsers,
                name: 'teams.teams-list.details.users',
                meta: {
                  view: 'users',
                },
              },
              {
                path: 'permissions',
                component: TeamsPermissions,
                name: 'teams.teams-list.details.permissions',
                meta: {
                  view: 'permissions',
                },
              },
            ],
          },
        ],
      },
      {
        path: 'user/:id',
        component: UserCard,
        name: 'teams.user',
      },
      {
        path: '',
        name: 'teams.empty',
        redirect: {
          name: 'teams.teams-list.details.users',
          params: {
            id: 'all',
          },
        },
      },
      {
        path: ':catchAll(.*)',
        name: 'teams.catch-all',
        redirect: {
          name: 'teams.teams-list.details.users',
          params: {
            id: 'all',
          },
        },
      },
    ],
  },
];
